export const outerSlideLeft = [
  {
    type: 'translateX',
    from: 0,
    to: -100,
    unit: '%',
  },
  {
    type: 'opacity',
    from: 1,
    to: 0,
    unit: '',
  },
];

export const innerSlideLeft = [
  {
    type: 'translateX',
    from: 0,
    to: -100,
    unit: '%',
  },
  {
    type: 'opacity',
    from: 0,
    to: 1,
    unit: '',
  },
];

export const outerSlideRight = [
  {
    type: 'translateX',
    from: -100,
    to: 0,
    unit: '%',
  },
  {
    type: 'opacity',
    from: 1,
    to: 0,
    unit: '',
  },
];

export const innerSlideRight = [
  {
    type: 'translateX',
    from: -100,
    to: 0,
    unit: '%',
  },
  {
    type: 'opacity',
    from: 0,
    to: 1,
    unit: '',
  },
];



// WEBPACK FOOTER //
// ./assets/javascripts/datas/_animations.js